import { Room } from '@material-ui/icons';
import { MarkerClientT } from 'bovaljaren-models';
import React, { ReactElement } from 'react';
import { isMobile } from '../../../../utils/app.helper';

type Props={
    marker: MarkerClientT;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
    onClick?:() => void;
};

const Marker: React.FC<Props> = ({ marker, onMouseEnter, onMouseLeave, onClick }): ReactElement => {
    return (
        <div
            onMouseOver={onMouseEnter}
            onMouseOut={onMouseLeave}
            className={`bv-mapping-image-marker bv-mapping-fade-in ${isMobile() ? ' bv-mapping-image-marker--mobile' : ''}`}
            onClick={(evt): void => {
                isMobile() && onClick && onClick();
            }}
            style={{ top: `calc(${marker.relativePosition.y}% - 42px )`, left:`calc(${marker.relativePosition.x}% - 21px)` }}>
            <Room className={`bv-mapping-image-room ${isMobile() ? ' bv-mapping-image-room--mobile' : ''}`}/>

        </div>
    );
};


export default Marker;